import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right",
  "use": "icon-arrow--right-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 10\" id=\"icon-arrow--right\"><path d=\"m6.645 9.697-.96-.93 2.865-3.15H0v-1.35h8.55l-2.865-3.15.96-.93 4.29 4.755-4.29 4.755Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol